import React, { useState } from 'react';
import { isValidPhone } from '../../utils/validation/phoneValidation';
import styles from './style.module.css';
import { Button, Error, InputText, Loading } from '../../components';
import SuccessMessage from '../../components/SuccessMessage';
import emailValidation from '../../utils/validation/emailValidation';
import cpfValidation from '../../utils/validation/cpfValidation';
import cnpjValidation from '../../utils/validation/cnpjValidation';
import InputMasked from '../../components/InputMasked';
import { useConfig } from '../../services/ConfigProvider';
import { deleteAccount } from '../../services/Login';
function DeleteAccount() {
  const config = useConfig();
  const API_URL = config?.REACT_APP_LOGIN_ADAPTER_URL || '';
  const HOME_URL = config?.REACT_APP_ALICE_HOST || '/';
  const [fields, setFields] = useState({
    nome: '',
    email: '',
    documento: '',
    telefone: '',
    message: '',
  });
  const [errors, setErrors] = useState({
    nome: '',
    email: '',
    documento: '',
    telefone: '',
    message: '',
  });
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const allFieldsFilled = Object.values(fields).every(
    (value) => value.trim() !== '',
  );

  const hasError = Object.values(errors).some((err) => err && err.length > 0);

  const isButtonDisabled = !allFieldsFilled || hasError;

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;
    setFields((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const validate = () => {
    let valid = true;
    const newErrors = {
      nome: '',
      email: '',
      documento: '',
      telefone: '',
      message: '',
    };

    if (!fields.nome.trim()) {
      newErrors.nome = 'Nome obrigatório.';
      valid = false;
    }

    if (!emailValidation(fields.email.trim())) {
      newErrors.email = 'E-mail inválido.';
      valid = false;
    }

    const documentoLimpo = fields.documento.replace(/\D/g, '');
    if (documentoLimpo.length === 11) {
      if (!cpfValidation(documentoLimpo)) {
        newErrors.documento = 'CPF inválido.';
        valid = false;
      }
    } else if (documentoLimpo.length === 14) {
      if (!cnpjValidation(documentoLimpo)) {
        newErrors.documento = 'CNPJ inválido.';
        valid = false;
      }
    } else {
      newErrors.documento = 'CPF ou CNPJ incompleto.';
      valid = false;
    }

    const phone = fields.telefone.trim();
    if (!isValidPhone(phone, 'BR')) {
      newErrors.telefone = 'Celular inválido.';
      valid = false;
    }
    if (!fields.message.trim()) {
      newErrors.message = 'Mensagem obrigatório.';
      valid = false;
    }
    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (validate()) {
      setLoading(true);
      deleteAccount(
        API_URL,
        fields.nome,
        fields.documento.replace(/\D/g, ''),
        fields.telefone.replace(/\D/g, ''),
        fields.email,
        fields.message,
      )
        .then((response) => {
          setLoading(false);
          console.log('Conta excluída com sucesso:', response);
          setSuccess(true);
        })
        .catch((error) => {
          setLoading(false);
          console.error('Erro ao excluir conta:', error);
        });
    }
  };

  return success ? (
    <SuccessMessage onHome={() => (window.location.href = HOME_URL)} />
  ) : (
    <>
      <Loading visibled={loading} />
      <div className={styles.container}>
        <div className={styles.frame}>
          <div className={styles.title}>Excluir minha conta</div>
          <form
            className={styles.formSection}
            onSubmit={handleSubmit}
            noValidate
          >
            <div className={styles.formSection}>
              <div className={styles.inputRow}>
                <div className={styles.inputColum}>
                  <InputText
                    placeholder="Nome*"
                    name="nome"
                    type="text"
                    value={fields.nome}
                    error={errors.nome.length > 0}
                    textError={errors.nome}
                    required={true}
                    onChange={handleChange}
                  />
                </div>
                <div className={styles.inputColum}>
                  <InputText
                    placeholder="E-mail*"
                    name="email"
                    type="text"
                    value={fields.email}
                    error={errors.email.length > 0}
                    textError={errors.email}
                    required={true}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className={styles.inputRow}>
                <div className={styles.inputColum}>
                  <InputMasked
                    placeholder="CPF / CNPJ*"
                    name="documento"
                    value={fields.documento}
                    mask={
                      fields.documento.replace(/\D/g, '').length >= 12
                        ? '99.999.999/9999-99'
                        : '999.999.999-999'
                    }
                    inputMode="text"
                    error={errors.documento.length > 0}
                    textError={errors.documento}
                    onChange={handleChange}
                  />
                </div>
                <div className={styles.inputColum}>
                  <InputMasked
                    placeholder="Telefone*"
                    name="telefone"
                    value={fields.telefone}
                    mask="(99)9 9999-9999"
                    inputMode="numeric"
                    error={errors.telefone.length > 0}
                    textError={errors.telefone}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>

            <div className={styles.inputColumTextArea}>
              <textarea
                className={
                  errors.message
                    ? `${styles.textareaField} ${styles.textareaFieldError}`
                    : styles.textareaField
                }
                name="message"
                id="message"
                placeholder="Pode nos contar um pouco mais sobre o porquê de ter decidido excluir sua conta?*"
                value={fields.message}
                onChange={handleChange}
                required
              />
              {errors.message && <Error text={errors.message} />}
            </div>

            <div className={styles.rowButton}>
              <Button
                id={styles.deleteAccount}
                text="Enviar"
                type="submit"
                disabled={isButtonDisabled}
              />
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default DeleteAccount;
